export * as firehose from '../firehose/examples';
// Re-export env at top level for env-loader compatibility (matches web pattern)
export * as env from '../firehose/examples/env';
